import React from 'react';

import { Button, Image } from '@rbilabs/universal-components';
import { Header as SectionHeader } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import Link from 'components/link';
import { Box, BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

export const ContentCardContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.contentCardContainer, style] });

export const ContentCardGridItem = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.contentCardGridItem, style] });

export const ClassicCardContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.classicCardContainer, style] });

export const ClassicCardImage = Image.withConfig({
  height: 'auto',
  borderTopLeftRadius: 16,
  borderBottomLeftRadius: 16,
  _web: {
    height: 'full',
  },
});

export const ClassicCardContent = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.classicCardContent, style] });

export const CardTitle = SectionHeader.withConfig({
  variant: 'headerTwo',
  marginBottom: 2,
  numberOfLines: 2,
  ellipsizeMode: 'tail',
});

export const CardDescription = withTypography({
  variant: 'copyTwo',
  numberOfLines: 2,
  ellipsizeMode: 'tail',
});

export const ButtonContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.buttonContainer, style] });

type CardButtonProps = {
  isChallenge?: boolean;
};

export const CardButton = Button.withConfig(({ isChallenge }: CardButtonProps) => ({
  variant: 'outline',
  ...(isChallenge && {
    variant: 'solid',
    backgroundColor: primitive.$meltyYellow,
    textDecorationColor: primitive.$meltyYellow,
    _hover: {
      backgroundColor: primitive.$meltyYellowDark45,
    },
    _pressed: {
      backgroundColor: primitive.$meltyYellowDark40,
    },
  }),
  size: 'md',
  _text: {
    ...(isChallenge && { color: primitive.$bbqBrown }),
  },
}));

export const CaptionedCardContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.captionedCardContainer, style] });

export const CaptionedCardImage = Image.withConfig({
  width: 'full',
  borderTopRadius: 16,
});

export const CaptionedCardContent = ClassicCardContent;

export const ImageOnlyCardImage = Image.withConfig({
  width: 'full',
  borderRadius: 16,
});

export const StyledLink = Link.withConfig({
  isUnderlined: true,
  isInline: true,
  variant: 'copyTwo',
  marginY: 2,
  _web: { cursor: 'pointer' },
});

const styles = StyleSheet.create({
  contentCardContainer: {
    backgroundColor: primitive.$white,
    borderRadius: 16,
    elevation: 2,
    marginHorizontal: spacing.$1,
    marginVertical: spacing.$2,
    position: 'relative',
    shadowOpacity: 0.25,
    shadowRadius: 2,
  },
  contentCardGridItem: { flex: 1 },
  classicCardContainer: { flexDirection: 'row', height: 136, position: 'relative' },
  classicCardContent: { flex: 1, padding: spacing.$4 },
  buttonContainer: {
    alignItems: 'flex-end',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: spacing.$4,
  },
  captionedCardContainer: { flexDirection: 'column' },
});
